export type RNG = () => number;

export function makeRng(seed: number): RNG {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function rngRange(rng: RNG, min: number, max: number): number {
  return min + (max - min) * rng();
}

export function rngInt(rng: RNG, minInclusive: number, maxExclusive: number): number {
  return Math.floor(minInclusive + (maxExclusive - minInclusive) * rng());
}

export function rngPick<T>(rng: RNG, items: readonly T[]): T {
  if (items.length === 0) throw new Error("rngPick: empty array");
  const item = items[rngInt(rng, 0, items.length)];
  return item as T;
}

export function rngGauss(rng: RNG, mean = 0, stdDev = 1): number {
  let u = 0;
  let v = 0;
  while (u === 0) u = rng();
  while (v === 0) v = rng();
  return mean + stdDev * Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
}
